<template>
  <v-container id="attendance-list">
    <v-form @submit.prevent="onSubmit" ref="form">
      <v-container>
        <h2 class="w-100 text-center title-insert">
          {{ tabId > 0 ? "Editar" : "Adicionar" }} Vocação
        </h2>
        <v-text-field
          label="Setor Econômico"
          name="setorEconomico"
          type="text"
          v-model="vocacao.setorEconomico"
          required
          :rules="rules"
          background-color="white"
        />

        <v-textarea
          label="CNAES"
          name="cnaes"
          type="text"
          v-model="vocacao.cnaes"
          required
          :rules="rules"
          background-color="white"
        />
        <v-textarea
          label="Ocupações"
          name="ocupacoes"
          type="text"
          v-model="vocacao.ocupacoes"
          required
          :rules="rules"
          background-color="white"
        />
        <v-textarea
          label="Observações"
          name="observacoes"
          type="text"
          v-model="vocacao.observacoes"
          required
          :rules="rules"
          background-color="white"
        />
        <v-row class="row-buttons mt-4">
          <v-btn
            type="button"
            color="error"
            text
            style="margin-left: 10px"
            @click="goToList()"
          >
            Cancelar
          </v-btn>
          <v-btn color="primary" type="submit"> Salvar </v-btn>
        </v-row>
      </v-container>
    </v-form>
  </v-container>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import { AppCityHeader } from "@/modules/city";

import { vocacoesApi } from "../Api/vocacoes";
export default {
  components: {
    AppCityHeader,
  },
  data() {
    return {
      vocacao: {},

      payload: {
        municipioId: this.$route.params.id,
      },
      isEdit: false,
      tabType: this.$route.params.tab,
      tabId: this.$route.params.tabId,
      rules: [(v) => !!v || "Campo Obrigatório"],
    };
  },
  mounted() {
    if (this.tabId > 0) {
      this.setLoading(true);
      vocacoesApi
        .find(this.tabId)
        .then(({ data }) => {
          this.vocacao = data;
          this.setLoading(false);
        })
        .catch((err) => {
          this.$notification.error("Erro ao encontrar Vocação");
          console.log("Erro no mounted ", err);
          this.setLoading(false);
        });
    }
  },
  methods: {
    ...mapActions(["setLoading"]),
    goToList() {
      this.$router.push(
        `/cidade/${this.payload.municipioId}/agenteTerritorial/${this.tabType}`
      );
    },
    async onSubmit() {
      const valid = await this.check();

      if (!valid) return;
      this.vocacao.municipioId = this.payload.municipioId;

      if (this.tabId > 0) {
        vocacoesApi
          .update(this.vocacao)
          .then(() => {
            this.$notification.success("Vocação editado com sucesso!");
            this.goToList();
          })
          .catch((err) => {
            this.$notification.error("Erro ao editar Ator");
            console.log("Erro no submit ", err);
          });
      } else {
        vocacoesApi
          .create(this.vocacao)
          .then(() => {
            this.$notification.success("Vocação criado com sucesso!");
            this.goToList();
          })
          .catch((err) => {
            this.$notification.error("Erro ao criar Vocação");
            console.log("Erro no submit ", err);
          });
      }
    },
    async check() {
      const isValid = await this.$refs.form.validate();
      return isValid;
    },
  },
};
</script>
<style scoped>
.title-insert {
  color: #5c8bb9;
}
.row-buttons {
  display: flex;
  justify-content: end;
}
</style>
